import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { log } from 'console';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
})
export class TimePickerComponent implements OnInit {
  constructor() {}

  timeJSON: any = { h: 0, m: 0, s: 0 };
  @Input('time') time = '0:0:0';
  @Output() timeChange = new EventEmitter<any>();

  @Input('readonly') readonly = false;
  @Input('format') format = 'h:m:s';

  ngOnInit(): void {
    const d = {};
    // if(this.time)
    this.format.split(':').forEach((e, i) => {
      d[e] = this.time.split(':')[i];
    });
    this.timeJSON = d;
    this.timeJSON.h = parseInt(this.timeJSON.h);
    this.timeJSON.m = parseInt(this.timeJSON.m);
    this.timeJSON.s = parseInt(this.timeJSON.s);
  }
  handleBlur(key, min, max) {
    if (this.timeJSON[key] > max) this.timeJSON[key] = max;
    if (this.timeJSON[key] < min) this.timeJSON[key] = min;

    this.time = this.format
      .split(':')
      .map((e) => this.timeJSON[e])
      .join(':');
    this.timeChange.emit(this.time);
  }
  updateValue(key, val) {
    //if (this.readonly) true;
    this.timeJSON[key] = this.timeJSON[key] + parseInt(val);
    if (key == 'h') {
      this.handleBlur(key, 0, 23);
    } else {
      this.handleBlur(key, 0, 59);
    }
  }
}
